import eyeSeen from "./eyeSeen.png";
import eyeSeenFocus from "./eyeSeenFocus.png";
import eyeUnseen from "./eyeUnseen.png";
import eyeUnseenFocus from "./eyeUnseenFocus.png";
import checkCircle from "./checkCircle.png";
import carouselFirst from "./carouselFirst.png";
import carouselSecond from "./carouselSecond.png";
import carouselThird from "./carouselThird.png";
import carouselFourth from "./carouselFourth.png";
import backIcon from "./backIcon.png";
import forgotPassword from "./forgotPassword.png";
import envelope from "./envelope.png";
import uploadExistingDataImg from "./uploadExistingDataImg.png";
import excelFileIcon from "./excelFileIcon.png";
import campaignConfirmationImg from "./campaignConfirmationImg.png";
import campaignSelectionIcon1 from "./campaignSelectionIcon1.png";
import campaignSelectionIcon2 from "./campaignSelectionIcon2.png";
import campaignSelectionIcon3 from "./campaignSelectionIcon3.png";
import logo from "./logo.png";
import inside from "./close-icon.png";
import outside from "./open-icon.png";
import dashboard from "./dashboard.png";
import dashboardHover from "./dashboard-hover.png";
import programs from "./programs.png";
import programsHover from "./programs-hover.png";
import customers from "./customers.png";
import customersHover from "./customers-hover.png";
import transaction from "./transactions.png";
import transactionHover from "./transactions-hover.png";
import financialAccount from "./financialAccount.png";
import financialAccountHover from "./financialAccount-hover.png";
import settings from "./settings.png";
import settingsHover from "./settings-hover.png";
import apiDocument from "./apiDocument.png";
import apiDocumentHover from "./apiDocument-hover.png";
import helpFAQs from "./helpFAQs.png";
import helpFAQsHover from "./helpFAQs-hover.png";
import logoutIcon from "./logout.png";
import logoutIconHover from "./logout-hover.png";
import dashboardIconOne from "./dashboardIcon1.png";
import dashboardIconTwo from "./dashboardIcon2.png";
import dashboardIconThree from "./dashboardIcon3.png";
import notifications from "./notifications.png";
import profilePic from "./profilePic.png";
import importIcon from "./importIcon.png";
import exportIcon from "./exportIcon.png";
import editIcon from "./editIcon.png";
import uploadIcon from "./uploadIcon.png";
import backIcon2 from "./backIcon2.png";
import lockIcon from "./lockIcon.png";
import downloadIcon from "./downloadIcon.png";
import uploadCSVIcon from "./uploadCSVIcon.svg";
import rocketLaunch from "./rocketLaunch.jpg";
import summaryFileIcon from "./summaryFileIcon.svg";
import fileUploadFailedIcon from "./fileUploadFailedIcon.svg";
import fileUploadSuccessIcon from "./fileUploadSuccessIcon.svg";
import profileImage from "./profileImage.png";
import programsCardBg from "./programsCard-bg.png";
import notFoundImg from "./notFoundImg.png";
import csvFileIcon from "./csvFileIcon.png";
import monitor from "./monitor.png";
import monitor_hover from "./monitor_hover.png";
import novus_logo from "./novus_loyalty_logo.png";
import novus_logo_white from "./novus_loyalty_logo_white.png";
import loading from "./loading.png";
import no_giftcard from "./no_giftcard.png";
import restart from "./restart.png";
import free from "./free.png";
import contact_mail from "./contact-mail.png";
import end_tour from "./end_tour.png";
import start_tour from "./start_tour.png";
import arrow_right from "./arrow_right.png";
import arrow_right_dark from "./arrow_right_dark.png";
import access_denied from "./access_denied.png";
import access_denied_hover from "./access_denied_hover.png";
import sign_in from "./Signin.jpg";
import earn_reward_points from "./Earn-Rewards-Points.jpg";
import customer_campagins from "./Campaigns.jpg";
import history_campagins from "./History.jpg";
import voucher_image from "./Vouchers.jpg";
import gift_cards from "./Gift-Cards.jpg";
import top_deals from "./Top-Deals.jpg";
import your_logo from "./customerlogo.png";
import whatsapp from "./integration_icons/whatsapp.png";
import facebook from "./integration_icons/facebook.png";
import twitter from "./integration_icons/twitter.png";
import twillio from "./integration_icons/twillio.png";
import freshmenu from "./integration_icons/freshmenu.png";
import ccd from "./integration_icons/ccd.png";
import flipkart from "./integration_icons/flipkart.png";
import magento from "./integration_icons/magento.png";
import paypal from "./integration_icons/paypal.png";
import jiomart from "./integration_icons/jiomart.png";
import linkedin from "./integration_icons/linkedin.png";
import razorpay from "./integration_icons/razorpay.png";
import shopify from "./integration_icons/shopify.png";
import twid from "./integration_icons/twid.png";
import yatra from "./integration_icons/yatra.png";
import sendgrid from "./integration_icons/sendgrid.png";
import redeem from "./Redeem.jpg";
import redeem_back from "./RedeenBackGround.png";
import storeIdback from "./Enter-StoreBack.jpg";
import storeIdFront from "./storeIdFront.png";
import header_main from "./customer_journey/header.png";
import home_section_left from "./customer_journey/home_section_left.png";
import home_section_right from "./customer_journey/home_section_right.png";
import home_tab_one from "./customer_journey/home_tab_one.png";
import rewards_button from "./customer_journey/rewards_button.png";
import upload_bill_icon from "./customer_journey/upload_bill_icon.png";
import upload_receipt from "./customer_journey/upload_receipt.png";
import redemption_successful from "./customer_journey/redemption_successful.png";
import gift_cards_layout from "./customer_journey/gift_cards_layout.png";
import in_store_redemtion_button from "./customer_journey/in_store_redemtion_button.png";
import redemption_box from "./customer_journey/redemption_box.png";
import top_deals_main from "./customer_journey/top_deals.png";
import payment_done from "./check.png";
import payment_failed from "./remove.png";
import goals from "./goals.png";
import admin_home from "./admin_home.png";
import email_marketing from "./email-marketing.png";
import contact_us from "./customer_journey/contact_us.png";

export { eyeSeen, eyeSeenFocus, eyeUnseen, eyeUnseenFocus, checkCircle, carouselFirst, carouselSecond, carouselThird, carouselFourth, backIcon, forgotPassword, envelope, uploadExistingDataImg, excelFileIcon, campaignConfirmationImg, campaignSelectionIcon1, campaignSelectionIcon2, campaignSelectionIcon3, logo, inside, outside, dashboard, dashboardHover, programs, programsHover, customers, customersHover, transaction, transactionHover, financialAccount, financialAccountHover, settings, settingsHover, helpFAQs, helpFAQsHover, logoutIcon, logoutIconHover, dashboardIconOne, dashboardIconTwo, dashboardIconThree, notifications, profilePic, importIcon, exportIcon, editIcon, uploadIcon, backIcon2, lockIcon, apiDocument, apiDocumentHover, downloadIcon, uploadCSVIcon, rocketLaunch, summaryFileIcon, fileUploadFailedIcon, fileUploadSuccessIcon, profileImage, programsCardBg, notFoundImg, csvFileIcon, monitor, monitor_hover, novus_logo, novus_logo_white, loading, no_giftcard, restart, free, contact_mail, end_tour, start_tour, arrow_right, arrow_right_dark, access_denied, access_denied_hover, sign_in, earn_reward_points, customer_campagins, history_campagins, voucher_image, gift_cards, top_deals, your_logo, whatsapp, facebook, freshmenu, flipkart, twitter, twillio, ccd, magento, paypal, jiomart, linkedin, razorpay, shopify, twid, yatra, sendgrid, header_main, home_section_left, home_section_right, home_tab_one, rewards_button, upload_bill_icon, upload_receipt, redemption_successful, gift_cards_layout, in_store_redemtion_button, redemption_box, top_deals_main, payment_done, payment_failed, goals, admin_home, email_marketing, contact_us };
